import { createReducer, on } from '@ngrx/store';
import * as repoBusinessActions from './repo-business.action';
import { Position, RepoBusiness, RepoContact } from '../../../models/repo-business/repo-business.model';

export interface RepoBusinessState {
  repoBusinesses: RepoBusiness[];
  positions: Position[];
  entities: { [id: string]: RepoContact };  // normalized map
  ids: string[];   
  loading: boolean;
  success: any | null;
  loadAllContacts: boolean;
  loadBusiness: boolean;
  loadContacts: boolean;
  loadContactsByRepoBusiness: boolean;
  error: any;
}

export const initialState: RepoBusinessState = {
  repoBusinesses: null,
  positions: null,
  entities: null,
  ids: [],
  loading: false,
  loadAllContacts: false,
  loadBusiness: false,
  loadContacts: false,
  loadContactsByRepoBusiness: false,
  error: null,
  success: null,
};

export const repoBusinessReducer = createReducer(
  initialState,
  on(repoBusinessActions.loadRepoBusinesses, (state) => ({ ...state, loading: true })),
  on(repoBusinessActions.loadRepoBusinessesSuccess, (state, { repoBusinesses }) => ({ ...state, repoBusinesses, loading: false, error: null, success: { loadRepoBusinesses: true }, loadBusiness:true })),
  on(repoBusinessActions.loadRepoBusinessesFailure, (state, { error }) => ({ ...state, loading: false, error })),

  on(repoBusinessActions.deletePosition, (state) => ({ ...state, loading: true })),
  on(repoBusinessActions.deletePositionSuccess, (state, { positions }) => ({ ...state, positions, loading: false, error: null, success: { deletePosition: true } })),
  on(repoBusinessActions.deletePositionFailure, (state, { error }) => ({ ...state, loading: false, error })),

  on(repoBusinessActions.deleteBusiness, (state) => ({ ...state, loading: true })),
  on(repoBusinessActions.deleteBusinessSuccess, (state, { deleted }) => ({ ...state, loading: false, error: null, success: { deleteBusiness: true } })),
  on(repoBusinessActions.deleteBusinessFailure, (state, { error }) => ({ ...state, loading: false, error })),

  on(repoBusinessActions.loadPositions, (state) => ({ ...state, loading: true })),
  on(repoBusinessActions.loadPositionsSuccess, (state, { positions }) => ({ ...state, positions, loading: false, error: null, success: { loadPositions: true } })),
  on(repoBusinessActions.loadPositionsFailure, (state, { error }) => ({ ...state, loading: false, error })),

  on(repoBusinessActions.loadContactsByRepoBusinessId, (state) => ({ ...state, loading: true })),

  on(repoBusinessActions.loadContactsByRepoBusinessIdSuccess, (state, { repoContacts }) => {
    const newEntities = repoContacts.reduce((entities, contact) => {
      entities[contact.repoContactId.toString()] = contact;
      return entities;
    }, {} as Record<string, any>);

    return {
      ...state,
      entities: newEntities,
      ids: repoContacts.map(c => c.repoContactId.toString()),
      loading: false,
      error: null,
      success: { loadContacts: true },
      loadContacts: true,
      loadContactsByRepoBusiness: true,
      loadAllContacts: false
    };
  }),

  on(repoBusinessActions.loadContactsSuccess, (state, { repoContacts }) => {
    const newEntities = repoContacts.reduce((entities, contact) => {
      entities[contact.repoContactId.toString()] = contact;
      return entities;
    }, {} as Record<string, any>);

    return {
      ...state,
      entities: newEntities,
      ids: repoContacts.map(c => c.repoContactId.toString()),
      loading: false,
      error: null,
      success: { loadAllContacts: true },
      loadAllContacts: true
    };
  }),

  on(repoBusinessActions.loadContactsByRepoBusinessIdFailure, (state, { error }) => ({ ...state, loading: false, error })),

  on(repoBusinessActions.saveRepoBusiness, (state) => ({ ...state, loading: true })),
  on(repoBusinessActions.saveRepoBusinessSuccess, (state, { repoBusiness }) => ({ ...state, repoBusinesses: [...state.repoBusinesses], loading: false, error: null, success: { saveRepoBusiness: true } })),
  on(repoBusinessActions.saveRepoBusinessFailure, (state, { error }) => ({ ...state, loading: false, error })),

  on(repoBusinessActions.savePosition, (state) => ({ ...state, loading: true })),
  on(repoBusinessActions.savePositionSuccess, (state, { position }) => ({ ...state, positions: [...state.positions], loading: false, error: null, success: { savePosition: true } })),
  on(repoBusinessActions.savePositionFailure, (state, { error }) => ({ ...state, loading: false, error })),

  on(repoBusinessActions.saveRepoContact, (state) => ({ ...state, loading: true })),
  on(repoBusinessActions.saveRepoContactSuccess, (state, { repoContact }) => ({ ...state, loading: false, error: null, success: { saveRepoContact: true } })),
  on(repoBusinessActions.saveRepoContactFailure, (state, { error }) => ({ ...state, loading: false, error })),
);
